<template>
  <div id="content">
    <div class="container">
      <div id="page-header">
        <div class="tools">
          <nav class="ito-tabs">
            <router-link class="align-items-center gap-1" :class="{ active: $route.name == 'daily_challenge' }" :to="{ name: 'daily_challenge' }" @click.native="getSoundClick">
              {{ $t('daily_challenge') }}
              <div class="noti-alert" v-if="user_info.dailychallenge_noti != 0 && user_info.lock_pacing ? !user_info.lock_pacing.some((i) => i.name == 'daily_challenge') : ''"></div>
            </router-link>
            <router-link class="align-items-center gap-1" :class="{ active: $route.name == 'daily_bonus' }" :to="{ name: 'daily_bonus' }" @click.native="getSoundClick">
              {{ $t('daily_bonus') }}
              <div class="noti-alert" v-if="user_info.dailybonus_gemreward != 0 && user_info.lock_pacing ? !user_info.lock_pacing.some((i) => i.name == 'daily_bonus') : ''"></div>
            </router-link>
            <router-link class="align-items-center gap-1" :class="{ active: $route.name == 'achievement' }" :to="{ name: 'achievement' }" @click.native="getSoundClick">
              {{ $t('menu_item_achievements') }}
              <div class="noti-alert" v-if="user_info.count_achieve_unread != 0 && user_info.lock_pacing ? !user_info.lock_pacing.some((i) => i.name == 'mission') : ''"></div>
            </router-link>
          </nav>
        </div>
      </div>
      <div id="achievement" class="card mt-3">
        <div class="card-body">
          <h5 class="card-title">
            <span class="title">{{ $t('menu_item_achievements') }}</span>
          </h5>

          <div class="card-content  d-flex flex-column gap-3 align-items-center justify-content-center" v-if="is_locked">
            <img src="/themes/ito/images/icons/icon-lock-big.svg" alt="">
            <p>{{ $t('feature_not_unlock') }}</p>
          </div>

          <div class="card-content p-0" v-else>
            <div class="description">
              {{ $t('complete_all_the_achievements_to_get_rewards') }}
            </div>
            <div id="achievement-content">
              <div class="achievement-list">
                <template v-for="(achievement, index) in achievements">
                  <achievement-item :achievement="achievement" @updateMission="updateMission" />
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getAchievements } from "../../models/achievement";
import AchievementItem from "./AchievementItem";

export default {
  name: "Achievement",
  components: { AchievementItem },

  data() {
    return {
      achievements: [],
      is_locked: this.$store.state.user_info.lock_pacing ? this.$store.state.user_info.lock_pacing.some((i) => i.name == 'mission') : false
    };
  },

  computed: {
    user_info() {
      return this.$store.state.user_info
    },

  },

  created() {
    if (!this.is_locked) {
      this.fetch();
    }

  },

  methods: {
    fetch() {
      const that = this;
      that.$store.commit("setLoading", true);
      axios.all([
        getAchievements(),
      ]).then(axios.spread((response) => {
        that.$store.commit("setLoading", false);
        if (response.data.code != 0) {
          return;
        }
        that.achievements = response.data.results.achieve || [];
        this.$nextTick(function () {
          initNanoScroller();
        })
        that.user_info.count_achieve_unread = response.data.results.count_achieve_unread || 0;
      }));
    },

    updateMission(data) {
      this.fetch();
    },

  }
}
</script>

<style scoped>
#achievement-content {
  min-height: 310px;
  max-height: calc(100vh - 390px);
  overflow: auto;
}
</style>
